import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { Waypoint } from "react-waypoint";
import SignUpButton from "../../../components/SignUpButton";

const StartInvestingInDigitalAssetsWithZipmex = (props) => {
  const { t } = useTranslation();

  return (
    <>
      {props.content.edges && (
        <div
          id="start-investing-in-digital-assets-with-zipmex-global"
          className="home steps-section"
        >
          <div className="container py-5">
            <div className="row">
              <div className="col-12 col-lg-6">
                <div
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-easing="ease-in-quad"
                >
                  <h2>{t("home.startInvesting.title")}</h2>
                </div>
                <Waypoint>
                  <div className="steps-area">
                    <div className="step-item active">
                      <span className="step-item-number"></span>
                      <div className="step-item-content">
                        <h5>{t("home.startInvesting.step1.title")}</h5>
                        <p>
                          <Trans
                            i18nKey="home.startInvesting.step1.description"
                            components={[
                              <a
                                href="https://zipmex.onelink.me/8NSq/15940e3a"
                                target="_blank"
                                rel="noreferrer noopener nofollow"
                              >
                                iOS
                              </a>,
                              <a
                                href="https://zipmex.onelink.me/8NSq/15940e3a"
                                target="_blank"
                                rel="noreferrer noopener nofollow"
                              >
                                Android
                              </a>,
                              <SignUpButton> Website</SignUpButton>,
                            ]}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="step-item active">
                      <span className="step-item-number"></span>
                      <div className="step-item-content">
                        <h5>{t("home.startInvesting.step2.title")}</h5>
                        <p>{t("home.startInvesting.step2.description")}</p>
                      </div>
                    </div>
                    <div className="step-item active">
                      <span className="step-item-number"></span>
                      <div className="step-item-content">
                        <h5>{t("home.startInvesting.step3.title")}</h5>
                        <p>{t("home.startInvesting.step3.description")}</p>
                      </div>
                    </div>
                  </div>
                </Waypoint>
              </div>
              <div className="d-none d-lg-block col-lg-6">
                <img
                  className="img-fluid"
                  src={props.imageBuyBtc.publicURL}
                  alt="Start investing in digital assets with Zipmex"
                  height={600}
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StartInvestingInDigitalAssetsWithZipmex;
